
import React from "react";
import { Input } from "@/components/ui/input";

interface UserSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const UserSearchBar: React.FC<UserSearchBarProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="relative">
      <Input
        type="text"
        placeholder="Buscar usuários..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="bg-[#181D24] border-[#222A35] text-white pl-10 focus-visible:ring-[#00B6F0]"
      />
      <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          className="text-gray-400"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </div>
    </div>
  );
};
